import { IconSetService } from '@coreui/icons-angular';
import { Component, Inject, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { iconSubset } from './app.icons';
import { CSP_TOKEN, UiServiceEnvironment, UiServicesLogger, UiServicesPayments, UiServiceWebSession } from '@drct-web-apps/ui-services';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    imports: [ RouterModule ]
})
export class AppComponent implements OnInit {
  readonly #iconSetService = inject(IconSetService);

  private readonly payments = inject(UiServicesPayments);
  private readonly session  = inject(UiServiceWebSession);
  public readonly env       = inject(UiServiceEnvironment);
  private readonly logger   = inject(UiServicesLogger);
  private readonly cspToken = inject(CSP_TOKEN);

  constructor() {
    this.#iconSetService.icons = { ...iconSubset };
  }

  ngOnInit(): void {
    this.loadPaymentScript()
        .then(() => {
          this.logger.log('Payment Script Successfully Loaded.');
          this.payments.paymentLibReady = true;
        }).catch(err => this.logger.error(`Payment Script Load Error. ${err}`));

    Array.from(document.getElementsByTagName("style"))?.forEach((style) => {
      style.setAttribute('nonce', this.cspToken);
    });
  }
  
  public onPaymentWindowClose(): void {
    this.payments.onPaymentWindowCloseClick();
  }

  public getMessages(): string {
    return this.session.message;
  }


  private loadPaymentScript(): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (document.querySelector(`script[id="monerisUrl"]`)) {
        resolve("Success");
        return;
      }

      const script   = document.createElement('script');
      script.src     = this.env.payUrl + `?v=${this.env.version}`;
      script.id      = "monerisUrl";
      script.async   = true;
      script.onload  = () => resolve("Success");
      script.onerror = () => reject(`Error Loading ${this.env.payUrl}`);
      
      document.body.appendChild(script);
    });
  }

}
